export const duration = {
  instant:    '100ms',
  fast:       '150ms',
  base:       '200ms',
  slow:       '300ms',
  deliberate: '500ms',
} as const;

export const easing = {
  standard:   'cubic-bezier(0.4, 0.0, 0.2, 1.0)',
  decelerate: 'cubic-bezier(0.0, 0.0, 0.2, 1.0)',
  accelerate: 'cubic-bezier(0.4, 0.0, 1.0, 1.0)',
  emphasized: 'cubic-bezier(0.34, 1.56, 0.64, 1.0)',
} as const;

export type DurationKey = keyof typeof duration;
export type EasingKey   = keyof typeof easing;
